const invoice = {
    draft: {
        label: window.i18n.__('Facture brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    due: {
        label: window.i18n.__('Facture à régler'),
        shortLabel: window.i18n.__('À régler'),
    },
    payinprogress: {
        label: window.i18n.__('Facture paiement partiel'),
        shortLabel: window.i18n.__('Paiement partiel'),
    },
    paid: {
        label: window.i18n.__('Facture payée'),
        shortLabel: window.i18n.__('Payée'),
    },
    late: {
        label: window.i18n.__('Facture en retard'),
        shortLabel: window.i18n.__('En retard'),
    },
    cancelled: {
        label: window.i18n.__('Facture annulée'),
        shortLabel: window.i18n.__('Annulée'),
    },
};

const estimate = {
    draft: {
        label: window.i18n.__('Devis brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Devis annulé'),
        shortLabel: window.i18n.__('Annulé'),
    },
    sent: {
        label: window.i18n.__('Devis envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Devis lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    accepted: {
        label: window.i18n.__('Devis accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
    refused: {
        label: window.i18n.__('Devis refusé'),
        shortLabel: window.i18n.__('Refusé'),
    },
    expired: {
        label: window.i18n.__('Devis expiré'),
        shortLabel: window.i18n.__('Expiré'),
    },
    advanced: {
        label: window.i18n.__('Devis acompte'),
        shortLabel: window.i18n.__('Acompte'),
    },
    partialinvoiced: {
        label: window.i18n.__('Devis partiellement facturé'),
        shortLabel: window.i18n.__('Partiellement facturé'),
    },
    invoiced: {
        label: window.i18n.__('Devis facturé'),
        shortLabel: window.i18n.__('Facturé'),
    },
};

const creditnote = {
    draft: {
        label: window.i18n.__('Avoir brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Avoir annulé'),
        shortLabel: window.i18n.__('Annulé'),
    },
    stored: {
        label: window.i18n.__('Avoir à solder'),
        shortLabel: window.i18n.__('À solder'),
    },
    partialspend: {
        label: window.i18n.__('Avoir partiel'),
        shortLabel: window.i18n.__('Partiel'),
    },
    spent: {
        label: window.i18n.__('Avoir soldé'),
        shortLabel: window.i18n.__('Soldé'),
    },
};

const delivery = {
    draft: {
        label: window.i18n.__('Bon de livraison brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    sent: {
        label: window.i18n.__('Bon de livraison envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Bon de livraison lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    partialinvoiced: {
        label: window.i18n.__('Bon de livraison partiellement facturé'),
        shortLabel: window.i18n.__('Partiellement facturé'),
    },
    invoiced: {
        label: window.i18n.__('Bon de livraison facturé'),
        shortLabel: window.i18n.__('Facturé'),
    },
    accepted: {
        label: window.i18n.__('Bon de livraison accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
};

const order = {
    draft: {
        label: window.i18n.__('Bon de commande brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Bon de commande annulé'),
        shortLabel: window.i18n.__('Annulé'),
    },
    sent: {
        label: window.i18n.__('Bon de commande envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Bon de commande lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    accepted: {
        label: window.i18n.__('Bon de commande accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
    expired: {
        label: window.i18n.__('Bon de commande expiré'),
        shortLabel: window.i18n.__('Expiré'),
    },
    advanced: {
        label: window.i18n.__('Bon de commande acompte'),
        shortLabel: window.i18n.__('Acompte'),
    },
    partialinvoiced: {
        label: window.i18n.__('Bon de commande partiellement facturé'),
        shortLabel: window.i18n.__('Partiellement facturé'),
    },
    invoiced: {
        label: window.i18n.__('Bon de commande facturé'),
        shortLabel: window.i18n.__('Facturé'),
    },
};

const proforma = {
    draft: {
        label: window.i18n.__('Proforma brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Proforma annulée'),
        shortLabel: window.i18n.__('Annulée'),
    },
    sent: {
        label: window.i18n.__('Proforma envoyée'),
        shortLabel: window.i18n.__('Envoyée'),
    },
    read: {
        label: window.i18n.__('Proforma lue'),
        shortLabel: window.i18n.__('Lue'),
    },
    accepted: {
        label: window.i18n.__('Proforma acceptée'),
        shortLabel: window.i18n.__('Acceptée'),
    },
    expired: {
        label: window.i18n.__('Proforma expirée'),
        shortLabel: window.i18n.__('Expirée'),
    },
    advanced: {
        label: window.i18n.__('Proforma acompte'),
        shortLabel: window.i18n.__('Acompte'),
    },
    partialinvoiced: {
        label: window.i18n.__('Proforma partiellement facturée'),
        shortLabel: window.i18n.__('Partiellement facturée'),
    },
    invoiced: {
        label: window.i18n.__('Proforma facturée'),
        shortLabel: window.i18n.__('Facturée'),
    },
};

const purOrder = {
    draft: {
        label: window.i18n.__('Bon de commande brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Bon de commande annulé'),
        shortLabel: window.i18n.__('Annulé'),
    },
    sent: {
        label: window.i18n.__('Bon de commande envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Bon de commande lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    accepted: {
        label: window.i18n.__('Bon de commande accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
    expired: {
        label: window.i18n.__('Bon de commande expiré'),
        shortLabel: window.i18n.__('Expiré'),
    },
    advanced: {
        label: window.i18n.__('Bon de commande acompte'),
        shortLabel: window.i18n.__('Acompte'),
    },
    partialInvoiced: {
        label: window.i18n.__('Bon de commande partiellement facturé'),
        shortLabel: window.i18n.__('Partiellement facturé'),
    },
    invoiced: {
        label: window.i18n.__('Bon de commande facturé'),
        shortLabel: window.i18n.__('Facturé'),
    },
};

const purInvoice = {
    draft: {
        label: window.i18n.__('Facture fournisseur brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    due: {
        label: window.i18n.__('Facture fournisseur à régler'),
        shortLabel: window.i18n.__('À régler'),
    },
    payinprogress: {
        label: window.i18n.__('Facture fournisseur paiement partiel'),
        shortLabel: window.i18n.__('Paiement partiel'),
    },
    paid: {
        label: window.i18n.__('Facture fournisseur payée'),
        shortLabel: window.i18n.__('Payée'),
    },
    late: {
        label: window.i18n.__('Facture fournisseur en retard'),
        shortLabel: window.i18n.__('En retard'),
    },
    cancelled: {
        label: window.i18n.__('Facture fournisseur annulée'),
        shortLabel: window.i18n.__('Annulée'),
    },
};

const purCreditNote = {
    draft: {
        label: window.i18n.__('Avoir fournisseur brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    cancelled: {
        label: window.i18n.__('Avoir fournisseur annulé'),
        shortLabel: window.i18n.__('Annulé'),
    },
    stored: {
        label: window.i18n.__('Avoir fournisseur à solder'),
        shortLabel: window.i18n.__('À solder'),
    },
    partialspend: {
        label: window.i18n.__('Avoir fournisseur partiel'),
        shortLabel: window.i18n.__('Partiel'),
    },
    spent: {
        label: window.i18n.__('Avoir fournisseur soldé'),
        shortLabel: window.i18n.__('Soldé'),
    },
};

const purDelivery = {
    draft: {
        label: window.i18n.__('Bon de livraison brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    sent: {
        label: window.i18n.__('Bon de livraison envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Bon de livraison lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    partialInvoiced: {
        label: window.i18n.__('Bon de livraison partiellement facturé'),
        shortLabel: window.i18n.__('Partiellement facturé'),
    },
    invoiced: {
        label: window.i18n.__('Bon de livraison facturé'),
        shortLabel: window.i18n.__('Facturé'),
    },
    accepted: {
        label: window.i18n.__('Bon de livraison accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
};

const document = {
    draft: {
        label: window.i18n.__('Brouillon'),
        shortLabel: window.i18n.__('Brouillon'),
    },
    sent: {
        label: window.i18n.__('Envoyé'),
        shortLabel: window.i18n.__('Envoyé'),
    },
    read: {
        label: window.i18n.__('Lu'),
        shortLabel: window.i18n.__('Lu'),
    },
    accepted: {
        label: window.i18n.__('Accepté'),
        shortLabel: window.i18n.__('Accepté'),
    },
};

export default {
    invoice,
    estimate,
    creditnote,
    order,
    delivery,
    proforma,
    purInvoice,
    purDelivery,
    purOrder,
    purCreditNote,
    document,
};
